/**
 * Manager who provide user location
 */

import Manager from "../../managers/Manager";
import Logger from "../../utils/Logger";
import GpsInfos from "../GpsInfos";
import * as GpsInfosEnum from "../GpsInfos";

export default class GpsManager extends Manager {

    /**
     * Default constructor
     * @param {ConfigGps} gpsConfiguration
     * @param {function} reverseGeocodingFunction
     */
    constructor(gpsConfiguration, reverseGeocodingFunction = null) {
        super();
        this.configuration = gpsConfiguration;
        this.currentWatcher = null;
        this.reverseGeocodingFunction = reverseGeocodingFunction;
        /**
         * @type {GpsInfos}
         */
        this.lastGpsInfos = new GpsInfos(GpsInfosEnum.GPS_STATE_UNKNOWN);
    }

    /**
     * Start monitoring GPS for infinite duration, until stop() is called
     */
    start() {
        Logger.log('Starting GPSManager');
        if (!this.configuration || !this.configuration.enabled) {
            // Configuration is disabled
            const gpsInfos = new GpsInfos(GpsInfosEnum.GPS_STATE_CAMPAIGN_DISABLED);
            this.setLocation(gpsInfos);
        } else if (!navigator.geolocation) {
            // No geolocation engine available
            const gpsInfos = new GpsInfos(GpsInfosEnum.GPS_STATE_NOT_SUPPORTED);
            this.setLocation(gpsInfos);
        } else {
            // Start the geolocation
            let self = this;
            this.currentWatcher = navigator.geolocation.watchPosition((location) => {
                Logger.log("Received coordinates : ");
                Logger.log(location);
                self.processLocation(location);
            });
        }
    }

    /**
     * Stop the current started GPS instance
     */
    stop() {
        Logger.log('Stopping GPSManager');
        if (navigator.geolocation && this.currentWatcher) {
            navigator.geolocation.clearWatch(this.currentWatcher);
            this.currentWatcher = null;
        } else {
            if (!this.currentWatcher) {
                Logger.log('No GPSManager instance running');
            }
        }
    }

    /**
     * Private method
     * Used to generate a GpsInfos object, with reverse geocoding enrichment if provided.
     *
     * @param location The HTML5 location object
     */
    processLocation(location) {
        if (this.configuration.geocodingEnabled && this.reverseGeocodingFunction) {
            // A reverse geocoding function has been set
            return this.reverseGeocodingFunction(location.coords.latitude, location.coords.longitude, (reverseGeocodingData) => {
                this.setLocation(new GpsInfos(
                    GpsInfosEnum.GPS_STATE_BOTH,
                    location.coords.latitude,
                    location.coords.longitude,
                    location.timestamp,
                    location.coords.accuracy,
                    reverseGeocodingData.city,
                    reverseGeocodingData.country,
                    reverseGeocodingData.countryCode,
                    reverseGeocodingData.postalCode,
                    reverseGeocodingData.streetNumber,
                    reverseGeocodingData.streetName));
            });
        } else {
            // Reverse geocoding disabled by configuration
            this.setLocation(new GpsInfos(GpsInfosEnum.GPS_STATE_BOTH,
                location.coords.latitude,
                location.coords.longitude,
                location.timestamp,
                location.coords.accuracy));
        }
    }

    /**
     * Use this setter to avoid conflicts with 'this'
     * @param {GpsInfos} gpsLocation
     */
    setLocation(gpsLocation) {
        this.lastGpsInfos = gpsLocation;
    }

    /**
     * Provide the last GpsInfos retrieved. Need to call start and collect data before.
     *
     * @returns {GpsInfos}
     */
    get() {
        return this.lastGpsInfos;
    }
}


// WEBPACK FOOTER //
// ./js/core/gps/manager/GpsManager.js